import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";

import {getCallerByCampaignAPI, getDispositionAPI, getSubdispositionAPI, LeadsAPI, getFilterDataAPI, getExportLeadCSVAPI, CallerAPI} from "./../../../API/Team/ReportAPI";
import Paginate from "../../../utils/Pagination";
import Layout from "./../../Layout";
import ContentLoader from "../../../utils/ContentLoader";
import ReactSelect from 'react-select';
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { Modal, Button, Offcanvas } from 'react-bootstrap';

const Report = () =>{

    const[callers, setCallers] = useState([]);
    const[datefilteroption, setDateFilterOption] = useState(null);
    const[startdate, setStartDate] = useState("");
    const[enddate, setEndDate] = useState("");
    const[selectcaller, setSelectCaller] = useState("");
    const[showcustomdates, setShowCustomDates] = useState(false);
    const[btnapplyloader, setBtnApplyLoader] = useState(false);
    const[btnclearloader, setBtnClearLoader] = useState(false);
    const[dataloader, setDataLoader] = useState(false);
    const[campaigns, setCampaigns] = useState([]);
    const[stages, setStages] = useState([]);
    const[dispositions, setDispositions] = useState([]);
    const[subdispositions, setSubDispositions] = useState([]);
    const[programs, setPrograms] = useState([]);
    const[institutes, setInstitutes] = useState([]);
    const [sources, setSources] = useState([]);

    const[leads, setLeads] = useState([]);
    const[leadcount, setLeadCount] = useState(0);
    const[payamount, setPayAmount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [filtersStored, setFiltersStored] = useState({});

    const [filtercampaign, setFilterCampaign] = useState("");
    const [filtercaller, setFilterCaller] = useState("");
    const [filterstage, setFilterStage] = useState([]);
    const [filterdisposition, setFilterDisposition] = useState([]);
    const [filtersubdisposition, setFilterSubdisposition] = useState([]);
    const [filterprogram, setFilterProgram] = useState([]);
    const [filterinstitute, setFilterInstitute] = useState([]);
    const [filtersource, setFilterSource] = useState([]);
    const [assignedstartdate, setAssignedStartDate] = useState(null);
    const [assignedenddate, setAssignedEndDate] = useState(null);

    const [totalrecords, setTotalRecords] = useState(0);
    const [isleadfiltermodal, setIsLeadFilterModal] = useState(false);
    const [isfilterapplied, setIsFilterApplied] = useState(false);

    const [exportbtnloader, setExportBtnLoader] = useState(false);
    const [assignmenttype, setAssignmentType] = useState(null);

    const [createdstartdate, setCreatedStartDate] = useState(null);
    const [createdenddate, setCreatedEndDate] = useState(null);

    const [filterparentcaller, setFilterParentCaller] = useState("");

    const [usertype, setUserType] = useState(1);

    const [teams, setTeams] = useState([]);
    const [filterteam, setFilterTeam] = useState("");


    const [filtersDraft, setFiltersDraft] = useState({ 
                                                    filterstage: [],
                                                    filterdisposition: [],
                                                    filtersubdisposition: [],
                                                    filterprogram: [],
                                                    filterinstitute: [],
                                                    filtersource: [],
                                                    //filtercampaign: "",
                                                    filtercaller: "",
                                                    filterparentcaller: "",
                                                    filterassignedstartdate: "",
                                                    filterassignedenddate: "",
                                                    filterassignmenttype: "",
                                                    filtercreatedstartdate: "",
                                                    filtercreatedenddate: "",
                                                    filterteam: ""
                                                });

    const perpagedata = 20;

    const assignmenttypelist = [    
                                    {
                                        value: "new",
                                        label: "Fresh Assignment"
                                    }, 
                                    {
                                        value: "reassign",
                                        label: "Reassigned"
                                    }
                                    
                                ]

    useEffect(()=>{

        /*getCampaignsAPI(setCampaigns);
        getCallersAPI(setCallers);
        getStagesAPI(setStages);*/

        //getFilterDataAPI(setCampaigns, setCallers, setStages, setPrograms, setInstitutes, setSources);
        getFilterDataAPI(setCallers, setStages, setPrograms, setInstitutes, setSources, setTeams);

        const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setUserType(loggeduserdata.usertype);

            //setLoggedName(loggeduserdata.name);

            //setProfileImage(loggeduserdata.image);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }

    }, []);

    useEffect(() =>{

        if (!filtersStored) return;

        const params = new URLSearchParams();

        Object.keys(filtersStored).forEach(key => {
            if (filtersStored[key]) {
                params.append(key, filtersStored[key]);
            }
        });

        params.append("page", currentPage);
        params.append("per_page", perpagedata);
        
        LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, params);

    }, [filtersStored, currentPage]);


    /*const handleFilterCampaign =(selcampaign) =>{

        setFilterCampaign(selcampaign);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercampaign: selcampaign.value
                        }));
    }*/

    const handleFilterCaller =(selcaller) =>{

        setFilterCaller(selcaller);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercaller: selcaller.value
                        }));
    }

    const handleFilterStage = (selstages) =>{
        console.log('Filter Stage=====' + JSON.stringify(selstages));

        setFilterStage(selstages);

        if(selstages)
        {
            let stagevalue = selstages.map(sgdatalist => sgdatalist.value);

            console.log('Selected stage value======' + stagevalue);

            setFiltersDraft(prev => ({
                            ...prev,
                            filterstage: stagevalue
                        }));

            getDispositionAPI(stagevalue, setDispositions);
        }

    }

    const handleFilterDispositon = (seldisposition) =>{
        console.log("Filter Disposition====" + JSON.stringify(seldisposition));

        setFilterDisposition(seldisposition);

        if(seldisposition)
        {
            let dispositionval = seldisposition.map(dpdatalist => dpdatalist.value);

            setFiltersDraft(prev => ({
                                ...prev,
                                filterdisposition: dispositionval
                            }));

            getSubdispositionAPI(dispositionval, setSubDispositions);
        }
    }

    const handleFilterSubdispositon = (selsubdisposition) =>{
        console.log("Filter Sub Disposition====" + JSON.stringify(selsubdisposition));

        setFilterSubdisposition(selsubdisposition);

        if(selsubdisposition)
        {
            let subdispositionval = selsubdisposition.map(sdpdatalist => sdpdatalist.value);

            setFiltersDraft(prev => ({
                                ...prev,
                                filtersubdisposition: subdispositionval
                            }));

        }

    }

    const handleFilterProgram = (selprogram) =>{
        console.log('Filter program====' + JSON.stringify(selprogram));

        setFilterProgram(selprogram);

        if(selprogram)
        {
            let programvalue = selprogram.map(prgdatalist => prgdatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filterprogram: programvalue
                            }));
        }
    }

    const handleFilterInstitute = (selinstitute) =>{
        console.log('Filter institute====' + JSON.stringify(selinstitute));

        setFilterInstitute(selinstitute);

        if(selinstitute)
        {
            let institutevalue = selinstitute.map(instdatalist => instdatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filterinstitute: institutevalue
                            }));
        }
    }

    const handleAssignedDateRange = (dates) => {

        const [startdate, enddate] = dates;

        setAssignedStartDate(startdate);
        setAssignedEndDate(enddate);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterassignedstartdate: format(startdate, "yyyy-MM-dd"),
                            filterassignedenddate: format(enddate, "yyyy-MM-dd")
                        }));

    }

    const handleFilterSource = (selsource) =>{
        console.log('Filter source====' + JSON.stringify(selsource));

        setFilterSource(selsource);

        if(selsource)
        {
            let sourcevalue = selsource.map(sourcedatalist => sourcedatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filtersource: sourcevalue
                            }));
        }
    }

    const handleLeadFilterModal = () =>{
		setIsLeadFilterModal(!isleadfiltermodal);
	}

	const handleLeadFilterModalHide = () =>{
        setIsLeadFilterModal(false);
    }

    const handleApplyFilter = (e) =>{        

        setFiltersStored({
                            ...filtersDraft
                        });

        setCurrentPage(1);

        console.log('Hide filter popup');

        setIsLeadFilterModal(false);

        setIsFilterApplied(true);

        //LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, filterparams);
    }

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    const handleResetFilter = (e) =>{
        setSelectCaller("");
        //setShowCallerStats(false);
        //setFilterCampaign("");
        setFilterCaller("");
        setFilterStage("");
        setFilterDisposition("");
        setFilterSubdisposition("");
        setFilterProgram("");
        setFilterInstitute("");
        setFilterSource("");
        setCreatedStartDate("");
        setCreatedEndDate("");
        setAssignedStartDate("");
        setAssignedEndDate("");
        setFilterParentCaller("");
        setFilterTeam("");

        setFiltersDraft({
                    filterstage: [],
                    filterdisposition: [],
                    filtersubdisposition: [],
                    filterprogram: [],
                    filterinstitute: [],
                    filtersource: [],
                    //filtercampaign: "",
                    filtercaller: "",
                    filterparentcaller: "",
                    filterassignedstartdate: "",
                    filterassignedenddate: "",
                    filtercreatedstartdate: "",
                    filtercreatedenddate: "",
                    filterteam: ""
        });

        setFiltersStored(null);
        setCurrentPage(1);

        setIsFilterApplied(false);
        
        LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, null);
    }

    const handleExportCSV = () =>{

        const exportparams = new URLSearchParams();

        if(!isfilterapplied)
        {
            getExportLeadCSVAPI(null, setExportBtnLoader);   

            return
        }

        Object.keys(filtersStored).forEach(key => {

            if (filtersStored[key]) 
            {
                exportparams.append(key, filtersStored[key]);
            }
            
        });

        getExportLeadCSVAPI(exportparams, setExportBtnLoader);
    }

    const handleFilterAssignmentType = (selassigntype) =>{

        setAssignmentType(selassigntype);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterassignmenttype: selassigntype ? selassigntype.value : ""
                        }));
    }

    const handleCreatedDateRange = (crdates) => {

        const [crstartdate, crenddate] = crdates;

        setCreatedStartDate(crstartdate);
        setCreatedEndDate(crenddate);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercreatedstartdate: format(crstartdate, "yyyy-MM-dd HH:mm:ss"),
                            filtercreatedenddate: format(crenddate, "yyyy-MM-dd HH:mm:ss")
                        }));

    }

    const handleFilterParentCaller = (selparentcaller) =>{
        console.log(selparentcaller);
        setFilterParentCaller(selparentcaller);

        let parentcallervalue = selparentcaller.map(parentcallerdatalist => parentcallerdatalist.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterparentcaller: parentcallervalue
                        }));
    }

    const handleFilterExecutiveCaller =(selcaller) =>{

        setFilterCaller(selcaller);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercaller: selcaller.value
                        }));
    }
    
    const handleFilterTeam =(selteam) =>{

        let teamvalue = selteam ? selteam.value : "";

        setFilterTeam(selteam);

        setFiltersDraft(prev => ({
                        ...prev,
                        filterteam: teamvalue
                    }));

        if(selteam)
        {
            CallerAPI(teamvalue, setCallers);
        }
        else
        {
            setCallers([]);
        }

    }

    const handleFilterExecutiveProgram = (selprogram) =>{
        console.log('Filter program====' + JSON.stringify(selprogram));

        setFilterProgram(selprogram);

        if(selprogram)
        {
            let programvalue = selprogram ? selprogram.value : "";


            setFiltersDraft(prev => ({
                                ...prev,
                                filterprogram: programvalue
                            }));
        }
    }


    console.log('Lead count=====' + leads.data);

    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Report</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="right">
                        <div className="row crm-filter-row-top align-items-center">

                            <div className="col-md-6 mb-1 d-flex align-items-center">

                            </div>

                            <div className="col-md-6 mb-1 d-flex justify-content-end align-items-center">
                                {exportbtnloader ?
                                    <button type="button" class="btn btn-success me-2"> 
                                        <div className="spinner-border" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </button>
                                :
                                    <button type="button" className="btn btn-success me-2" onClick={handleExportCSV}>
                                        <i className="fa fa-download me-2"></i>Export Lead CSV                                    
                                    </button>
                                }

                                <button className="btn btn-info me-2" onClick={handleLeadFilterModal}>
                                    <i className="ti ti-filter me-2"></i> Filter
                                </button>

                                <button type="button" className="btn btn-dark me-2" onClick={handleResetFilter}>
                                    <i className="fa fa-undo me-2"></i>Clear Filter
                                </button>


                            </div>
                        </div>

                        {usertype === 1 ?

                            <Offcanvas show={isleadfiltermodal} onHide={handleLeadFilterModalHide} placement="end" className="offcanvas-custom">
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title id="contained-modal-title-vcenter">Filter Leads</Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    <div class="row crm-filter-row-bottom align-items-end">

                                        {/*<div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Campaign</label>
                                            <ReactSelect className="" value={filtercampaign} onChange={handleFilterCampaign} options={campaigns} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Campaign"></ReactSelect>
                                        </div>*/}

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Callers</label>
                                            <ReactSelect className="" value={filterparentcaller} onChange={handleFilterParentCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Lead Parent Owner" isMulti></ReactSelect>
                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Callers</label>
                                            <ReactSelect className="" value={filtercaller} onChange={handleFilterCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Caller"></ReactSelect>
                                        </div>


                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Stage</label>
                                            <ReactSelect className="" value={filterstage} onChange={handleFilterStage} options={stages} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>


                                        </div>
                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Disposition</label>
                                            <ReactSelect className="" value={filterdisposition} onChange={handleFilterDispositon} options={dispositions} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>
                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Sub-Disposition</label>
                                            <ReactSelect className="" value={filtersubdisposition} onChange={handleFilterSubdispositon} options={subdispositions} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Subdisposition" isMulti></ReactSelect>
                                        </div>


                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Program</label>
                                            <ReactSelect className="" value={filterprogram} onChange={handleFilterProgram} options={programs} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>

                                        </div>
                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Institute</label>
                                            <ReactSelect className="" value={filterinstitute} onChange={handleFilterInstitute} options={institutes} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Institute" isMulti></ReactSelect>

                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Source</label>
                                            <ReactSelect className="" value={filtersource} onChange={handleFilterSource} options={sources} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Source" isMulti></ReactSelect>

                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Assignment Type</label>
                                            <ReactSelect className="" value={assignmenttype} onChange={handleFilterAssignmentType} options={assignmenttypelist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Assignment Type"></ReactSelect>


                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Assigned Date</label>
                                            <DatePicker  className="form-control" selected={assignedstartdate} onChange={ handleAssignedDateRange } startDate={assignedstartdate} endDate={assignedenddate} selectsRange isClearable placeholderText="Select assigned date range" />

                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Created Date</label>
                                            <DatePicker  className="form-control" selected={createdstartdate} onChange={ handleCreatedDateRange } startDate={createdstartdate} endDate={createdenddate} selectsRange isClearable showTimeSelect timeIntervals={15} placeholderText="Select created date range" dateFormat="dd/MM/yyyy h:mm aa" />

                                        </div>
                                    </div>

                                    <div class="crm-filter-actions">
                                        <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleLeadFilterModalHide}>Close</button>

                                        <button type="button" className="btn btn-primary me-2" onClick={handleApplyFilter}>
                                                <i className="ti ti-search me-2"></i>Apply Filter
                                        </button>

                                    </div>
                                </Offcanvas.Body>

                            </Offcanvas>
                        :
                            <Offcanvas show={isleadfiltermodal} onHide={handleLeadFilterModalHide} placement="end" className="offcanvas-custom">
                                <Offcanvas.Header closeButton>
                                    <Offcanvas.Title id="contained-modal-title-vcenter">Filter Leads</Offcanvas.Title>
                                </Offcanvas.Header>
                                <Offcanvas.Body>
                                    <div class="row crm-filter-row-bottom align-items-end">

                                        {/*<div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Campaign</label>
                                            <ReactSelect className="" value={filtercampaign} onChange={handleFilterCampaign} options={campaigns} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Campaign"></ReactSelect>
                                        </div>*/}

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Team</label>
                                            <ReactSelect className="" value={filterteam} onChange={handleFilterTeam} options={teams} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Team" isClearable={true}></ReactSelect>
                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Callers</label>
                                            <ReactSelect className="" value={filtercaller} onChange={handleFilterExecutiveCaller} options={callers} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Caller" isClearable={true}></ReactSelect>
                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Program</label>
                                            <ReactSelect className="" value={filterprogram} onChange={handleFilterExecutiveProgram} options={programs} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Program" isClearable={true}></ReactSelect>

                                        </div>


                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Stage</label>
                                            <ReactSelect className="" value={filterstage} onChange={handleFilterStage} options={stages} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>


                                        </div>
                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Disposition</label>
                                            <ReactSelect className="" value={filterdisposition} onChange={handleFilterDispositon} options={dispositions} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>
                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Sub-Disposition</label>
                                            <ReactSelect className="" value={filtersubdisposition} onChange={handleFilterSubdispositon} options={subdispositions} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Subdisposition" isMulti></ReactSelect>
                                        </div>


                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Program</label>
                                            <ReactSelect className="" value={filterprogram} onChange={handleFilterProgram} options={programs} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>

                                        </div>
                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Institute</label>
                                            <ReactSelect className="" value={filterinstitute} onChange={handleFilterInstitute} options={institutes} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Institute" isMulti></ReactSelect>

                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Source</label>
                                            <ReactSelect className="" value={filtersource} onChange={handleFilterSource} options={sources} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Source" isMulti></ReactSelect>

                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Assignment Type</label>
                                            <ReactSelect className="" value={assignmenttype} onChange={handleFilterAssignmentType} options={assignmenttypelist} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Assignment Type"></ReactSelect>


                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Assigned Date</label>
                                            <DatePicker  className="form-control" selected={assignedstartdate} onChange={ handleAssignedDateRange } startDate={assignedstartdate} endDate={assignedenddate} selectsRange isClearable placeholderText="Select assigned date range" />

                                        </div>

                                        <div className="col-md-12 mb-1">
                                            <label class="crm-filter-label">Created Date</label>
                                            <DatePicker  className="form-control" selected={createdstartdate} onChange={ handleCreatedDateRange } startDate={createdstartdate} endDate={createdenddate} selectsRange isClearable showTimeSelect timeIntervals={15} placeholderText="Select created date range" dateFormat="dd/MM/yyyy h:mm aa" />

                                        </div>
                                    </div>

                                    <div class="crm-filter-actions">
                                        <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleLeadFilterModalHide}>Close</button>

                                        <button type="button" className="btn btn-primary me-2" onClick={handleApplyFilter}>
                                                <i className="ti ti-search me-2"></i>Apply Filter
                                        </button>

                                    </div>
                                </Offcanvas.Body>

                            </Offcanvas>
                        }


                    </div>
                </div>

                {/*<div className="col-md-12">
                    <div className="card crm-leads-filter-card">
                        <div className="card-body">
                            <div className="row crm-filter-row-top">
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Campaign</label>
                                    <select className="form-select" name="campaign" value={selectcampaign} onChange={handleSelectCampaign}>
                                        <option value="">Select Campaign</option>
                                        {campaigns.map((campaign) =>
                                            (
                                                <option key={campaign.id} value={campaign.id}>{campaign.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Caller</label>
                                    <select className="form-select" name="caller" value={selectcaller} onChange={handleSelectCaller}>
                                        <option value="">Select Caller</option>
                                        {callers.map((caller) =>
                                            (
                                                <option key={caller.id} value={caller.id}>{caller.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Stage</label>
                                    <select className="form-select" name="stage" value={selectstage} onChange={handleSelectStage}>
                                        <option value="">Select Stage</option>
                                        {stages.map((stage) =>
                                            (
                                                <option key={stage.id} value={stage.id}>{stage.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label class="crm-filter-label">Disposition</label>
                                    <select className="form-select" name="disposition" value={selectdisposition} onChange={handleSelectDisposition}>
                                        <option value="">Select Disposition</option>
                                        {dispositions.map((disposition) =>
                                            (
                                                <option key={disposition.id} value={disposition.id}>{disposition.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                                <div className="col-md-3 mb-3">
                                    <label class="crm-filter-label">Sub-Disposition</label>
                                    <select className="form-select" name="subdisposition" value={selectsubdisposition} onChange={handleSelectSubDisposition}>
                                        <option value="">Select SubDisposition</option>
                                        {subdispositions.map((subdisposition) =>
                                            (
                                                <option key={subdisposition.id} value={subdisposition.id}>{subdisposition.name}</option>

                                            ))
                                        }
                                    </select>
                                </div>
                            </div>

                            <div class="row crm-filter-row-bottom align-items-end">
                                <div className="col-md-2 mb-3">
                                    <label class="crm-filter-label">Date Filter</label>
                                    <select className="form-select" name="date-filter" onChange={handleDateFilterOption}>
                                        <option value="">Select Date</option>
                                        <option value="today">Today</option>
                                        <option value="yesterday">Yesterday</option>
                                        <option value="last7days">Last 7 Days</option>
                                        <option value="last30days">Last 30 Days</option>
                                        <option value="thismonth">This Month</option>
                                        <option value="lastmonth">Last Month</option>
                                        <option value="customdate">Custom Date</option>
                                    </select>
                                </div>

                                <div className={ showcustomdates ? 'col-md-2 mb-3 custom-date-filter dropdown' : 'col-md-2 mb-3 custom-date-filter dropdown d-none'}>
                                    <label class="crm-filter-label">Start Date</label>
                                    <input className="form-control" type="date" name="startdate" placeholder="Start Date" onChange={handleStartDate} />

                                </div>
                                <div className={ showcustomdates ? 'col-md-2 mb-3 custom-date-filter dropdown' : 'col-md-2 mb-3 custom-date-filter dropdown d-none'}>
                                    <label class="crm-filter-label">End Date</label>

                                    <input className="form-control" type="date" name="enddate" placeholder="End Date" onChange={handleEndDate} />
                                </div>

                                <div className="col-md-3 mb-3">
                                    <label class="crm-filter-label opacity-0">Actions</label>
                                    <div class="crm-filter-actions">
                                        <button type="button" className="btn btn-primary" onClick={handleApplyFilter}>
                                                <i className="ti ti-search me-2"></i>Apply Filter
                                        </button>

                                        <button type="button" className="btn btn-dark" onClick={handleResetFilter}>
                                            <i className="fa fa-undo me-2"></i>Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>*/}

                {/*<div className="col-md-12">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="card fresh">
                                <div className="card-body p-3 d-flex align-items-center mx-auto">
                                    <div>
                                        <div className="fs-25 fw-semibold widget-text text-center">{leadcount}</div>
                                        <div className="text-body-secondary fw-semibold widget-heading">Leads</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card follow">
                                <div className="card-body p-3 d-flex align-items-center mx-auto">
                                    <div>
                                        <div className="fs-25 fw-semibold widget-text text-center">{payamount}</div>
                                        <div className="text-body-secondary fw-semibold widget-heading">Paid Reg. Fee</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>*/}

                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="mb-2">
                                <strong>Total Records:</strong> {leadcount}
                            </div>
                            <div className="table-responsive table-wrapper">
                                {dataloader ?

                                    <ContentLoader />
                                :
                                <table className="table table-data-section" id="faqlist">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Contact</th>
                                            <th>Location</th>
                                            <th>Program</th>
                                            <th>Institute</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                    leads && leads.length > 0 ?
                                        leads.map(lead =>
                                            <tr key={lead.id}>
                                                <td>{lead.name}</td>
                                                <td>{lead.email}</td>
                                                <td>{lead.contact}</td>
                                                <td>{lead.location}</td>
                                                <td>{lead.program}</td>
                                                <td>{lead.institute}</td>
                                                <td>
                                                    <span class="badge badge-tag badge-purple-light">{lead.stagename}</span>
                                                </td>
                                            </tr>
                                        )
                                    :
                                        <tr>
                                            <td colSpan="7">No data found...</td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }

                            </div>
                        </div>
                    </div>
                </div>

                {pagecount > 1 &&
                <div className="pagination-section mt-3">

                    <nav>
                        <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                    </nav>
                </div>
                }
            </div>

        </div>
    </Layout>
    );
}

export default Report;
